<template>
  <div class="flex flex-col">
    <div
      class="relative mb-6 h-56 w-full overflow-hidden rounded-2xl lg:mb-8"
      :class="{
        'before:absolute before:left-0 before:top-0 before:h-full before:w-full before:bg-gradient-to-b before:from-jag-950/0 before:via-jag-950/0 before:to-jag-950/80':
          !data.img.hideGradient,
      }"
    >
      <img
        :src="data.img.src"
        :width="data.img.width"
        :height="data.img.height"
        :alt="data.img.alt"
        class="h-full w-full object-cover"
      />
      <Badge
        v-if="data.badge"
        :label="data.badge.label"
        :theme="onDark ? 'green-on-dark' : 'green'"
        :icon="data.badge.icon"
        class="absolute bottom-4 left-4"
      />
    </div>

    <div
      v-if="data.tag"
      class="!mb-3 lg:!mb-4"
      :class="onDark ? 'tag-on-dark' : 'tag'"
    >
      {{ data.tag }}
    </div>
    <h3
      class="!mb-4 !text-xl !font-bold !tracking-tight lg:!mb-6 lg:!text-xl"
      :class="{ 'text-white': onDark }"
    >
      {{ data.title }}
    </h3>
    <div
      v-if="data.description"
      class="text-base font-light lg:text-lg"
      :class="[
        data.link || data.button ? '!mb-6 lg:!mb-8' : '!mb-0',
        { 'text-white': onDark },
      ]"
      v-html="data.description"
    ></div>

    <component
      :is="buttonComponent"
      v-if="data.link"
      :label="data.link.label"
      :url="data.link.url"
      size="large"
      arrow="right"
      :on-dark="onDark ?? false"
      class="mt-auto w-full"
      :class="{
        '!justify-start !fill-green-800 !text-green-800':
          buttonType === 'text' || buttonType === 'text-small',
      }"
      :icon-left="data.link.leftIcon ?? ''"
      @click="data.link.click"
    />

    <BtnPrimary
      v-if="data.button && buttonType === 'primary'"
      :label="data.button.label"
      size="large"
      arrow="none"
      :icon-left="data.button.leftIcon"
      class="mt-auto !w-full !justify-start lg:!w-max"
      @click="emit('click')"
    />

    <BtnSecondary
      v-if="data.button && buttonType === 'secondary'"
      :label="data.button.label"
      :icon-left="data.button.leftIcon"
      size="large"
      arrow="none"
      class="mt-auto !w-full !justify-start lg:!w-max"
      @click="emit('click')"
    />
    <p v-if="data.disclaimer" class="mt-2 text-sm text-grey-700">
      {{ data.disclaimer }}
    </p>
  </div>
</template>
<script setup lang="ts">
import type { Segment } from "@/types";

import BtnText from "@/components/btn/Text.vue";
import BtnPrimary from "@/components/btn/Primary.vue";
import BtnSecondary from "@/components/btn/Secondary.vue";

const props = defineProps<{
  data: CardImageData;
  segment: Segment;
  buttonType?: "text" | "text-small" | "primary" | "secondary";
  onDark?: boolean;
}>();

const buttonComponent = computed(() => {
  if (props.buttonType === "text" || props.buttonType === "text-small") {
    return BtnText;
  }
  if (props.buttonType === "primary") {
    return BtnPrimary;
  }
  return BtnSecondary;
});

const emit = defineEmits(["click"]);
</script>
